@if (renderState(); as state) {
  @if (state.value && label) {
    <span>{{label}}</span>
  }
  @if (state.value && !renderAsEmail) {
    <div
      [matTooltip]="tooltipText()"
      [matTooltipDisabled]="!tooltipText()"
      [class.einvoice-field-selectable]="state.selectionEntry !== undefined"
      [class.einvoice-field-selected]="selectedModelPaths().has(state.selectionEntry?.modelPath ?? '')"
      [class.einvoice-field-active]="state.selectionEntry?.modelPath === activeModelPath()"
      [class.einvoice-field-search-match]="isSearchMatch()"
      [class.einvoice-field-current-search-match]="isCurrentSearchMatch()"
      [attr.data-search-id]="searchFieldId"
      (click)="select($event)">{{state.value}}<ng-content></ng-content></div>
  }
  @if (state.value && renderAsEmail) {
    <div
      [class.einvoice-field-selectable]="state.selectionEntry !== undefined"
      [class.einvoice-field-selected]="selectedModelPaths().has(state.selectionEntry?.modelPath ?? '')"
      [class.einvoice-field-active]="state.selectionEntry?.modelPath === activeModelPath()"
      [class.einvoice-field-search-match]="isSearchMatch()"
      [class.einvoice-field-current-search-match]="isCurrentSearchMatch()"
      [attr.data-search-id]="searchFieldId"
      (click)="select($event)"><a [matTooltip]="tooltipText()" [matTooltipDisabled]="!tooltipText()" href="mailto:{{state.value}}?subject={{emailSubject}}">{{state.value}}</a><ng-content></ng-content></div>
  }
}

